// FilterPanel.js
import React from 'react';
import {
    Box,
    Grid,
    TextField,
    Slider,
    Button,
    Typography,
    CircularProgress,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from '@mui/material';
import DateRangePicker from './DateRangePicker';
import InfoButton from './InfoButton';
import InfoModal from './InfoModal';

const FilterPanel = ({
    filters,
    onFilterChange,
    onApplyFilters,
    isLoading,
    searchHistory,
    showViewMode = false
}) => {
    const [openInfo, setOpenInfo] = React.useState(false);

    return (
        <Box sx={{ borderRadius: 2, display: 'flex', justifyContent: 'space-between', px: { xs: 1.5, sm: 2 }, pb: { xs: 0.5, sm: 1.25 }, fontSize: { xs: '0.9rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1.1rem' } }}>
            <Grid container spacing={{ xs: 1, sm: 3, md: 1, lg: 4, xl: 6 }} alignItems="center">
                <Grid item xs={12} md={12} lg={6} xl={6} sx={{ width: { xs: 200, sm: 200, md: 200, lg: 200, xl: 380 } }} >
                    <TextField
                        fullWidth
                        size="medium"
                        label="Query"
                        placeholder="Enter your query ..."
                        value={(filters.query || '').replace(/_/g, ' ')}
                        onChange={(e) => onFilterChange('query', e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} sx={{ width: { xs: 200, sm: 200, md: 300, lg: 300, xl: 400 } }} >
                    <DateRangePicker
                        value={{ startDate: filters.startDate, endDate: filters.endDate }}
                        onChange={(val) => {
                            if (val) {
                                onFilterChange('startDate', val.startDate ? new Date(val.startDate) : filters.startDate);
                                onFilterChange('endDate', val.endDate ? new Date(val.endDate) : filters.endDate);
                            }
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3} xl={3} >
                    <FormControl fullWidth>
                        <InputLabel>Search Type</InputLabel>
                        <Select
                            value={filters.value}
                            label="Search Type"
                            onChange={(e) => onFilterChange('value', e.target.value)}
                        >
                            <MenuItem value={1}>Semantic Search</MenuItem>
                            <MenuItem value={2}>Keyword Search</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6} sx={{ mt: { xs: 0.5, md: 0 } }}>
                    <Typography gutterBottom sx={{ mb: { xs: 0.5, md: 1 } }}>Relevance</Typography>
                    <Slider
                        value={filters.threshold}
                        onChange={(_, value) => onFilterChange('threshold', value)}
                        valueLabelDisplay="auto"
                        sx={{
                            color: 'rgba(94, 79, 170, 1)',
                            '& .MuiSlider-thumb': {
                                backgroundColor: 'rgba(94, 79, 170, 1)',
                            },
                            '& .MuiSlider-track': {
                                backgroundColor: 'rgba(94, 79, 170, 1)',
                            },
                            '& .MuiSlider-rail': {
                                backgroundColor: '#d8d8d8',
                            }
                        }}
                        step={0.1}
                        marks={[
                            {
                                value: 1,
                                label: 'Low',
                            },
                            {
                                value: 2,
                                label: 'High',
                            },
                        ]}
                        min={1}
                        max={2}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3} xl={3} sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-start' }, mb: 1 }}>
                    <Button
                        variant="contained"
                        onClick={onApplyFilters}
                        disabled={isLoading}
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{
                            width: { xs: '100%', md: 'auto' }, height: { xs: 32, md: 34, lg: 40, xl: 46 }, backgroundColor: 'rgba(94, 79, 170, 1)', color: '#fff', borderRadius: 1,
                            '&:hover': {
                                backgroundColor: '#9B86FF',     // darker shade on hover
                                cursor: 'pointer'
                            }
                        }}
                    >
                        {isLoading
                            ? 'Loading...'
                            : searchHistory && searchHistory.length > 0
                                ? 'Apply Filters Within Cluster'
                                : 'Apply Filters'
                        }
                    </Button>

                </Grid>

                {showViewMode && (
                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                        <FormControl fullWidth>
                            <InputLabel>View Mode</InputLabel>
                            <Select
                                value={filters.viewMode || 'Category-wise'}
                                label="View Mode"
                                onChange={(e) => {
                                    // handleLocalChange('viewMode', e.target.value);
                                    // View mode change should probably trigger immediately or at least update global
                                    onFilterChange('viewMode', e.target.value);
                                }}
                            >
                                <MenuItem value="Category-wise">Category-wise</MenuItem>
                                <MenuItem value="Company-wise">Company-wise</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                )}
            </Grid>
            {/* <Grid container spacing={{ xs: 1, sm: 2, md: 1, lg: 4, xl: 6  }} alignItems="center">
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3} sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-start' }}}>
                    <InfoButton onClick={() =>setOpenInfo(true)} />
                </Grid>
                <InfoModal
                        open={openInfo}
                        onClose={() => setOpenInfo(false)}
                        title="Dashboard Information"
                        description={`This page helps you explore categories, keywords and insights.\n\nYou can search, expand categories and review insights.`}
                        points={[
                        "View all categories with their insights",
                        "Analyze trending issues/Alerts under each category",
                        "Naviate deeper into Subcategories",
                        "See the companies-wise distribution associated with each category",
                        "See the Spatial ditribution of issues across India of the selected category",
                        ]}
                />
            </Grid> */}
        </Box>
    );
};

export default FilterPanel;